import { Space, Typography } from 'antd'
import { GenericRequestCardItemProps } from './types'

const GenericRequestCardItem: React.FC<GenericRequestCardItemProps> = ({
  children,
  label,
}) => (
  <Space size="small" align="center">
    <Typography.Text strong style={{ minWidth: 'fit-content' }}>
      {label}:
    </Typography.Text>
    {children}
  </Space>
)

export default GenericRequestCardItem
